import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setAppNavigate } from "@utils/navigation/app-nav-bridge";
import { parseAppDeepLink } from "@lib/platform/app-origin";

/** Registers React Router navigate for native push / deep-link handlers. */
export function PushNavigationHost() {
  const navigate = useNavigate();

  useEffect(() => {
    const go = (rawUrl: string) => {
      const path = parseAppDeepLink(rawUrl);
      if (import.meta.env.DEV) {
        console.info("[push] Navigate from URL", rawUrl, "→", path);
      }
      navigate(path.startsWith("/") ? path : `/${path}`);
    };

    setAppNavigate(go);
    return () => setAppNavigate(null);
  }, [navigate]);

  return null;
}
